module.exports = __webpack_public_path__ + "img/appreciate.9d09eb15.svg";